import styled from "styled-components";
import { BORDER_RADIUS, COLORS, FONT_FAMILY, FONT_WEIGHT } from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const Banner = styled.section`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  width: calc(100% - 48px);
  max-width: 1464px;
  margin: 24px auto 40px;
  padding: 24px 32px;
  border: 1px solid ${COLORS.AbsoluteWhite};
  border-radius: ${BORDER_RADIUS.radius24};
  background: ${COLORS.Cultured};
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding: 24px;
    margin-bottom: 24px;
  }
`;

export const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const ActionLink = styled.a<{ $biggerCursor: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: 10px;
  padding: 12px 20px;
  min-height: 44px;
  border-radius: ${BORDER_RADIUS.radius24};
  background: ${COLORS.VividAuburn};
  color: ${COLORS.Cultured};
  font-family: ${FONT_FAMILY.poppins};
  font-size: 14px;
  font-weight: ${FONT_WEIGHT.semiBold};
  text-decoration: none;
  cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  transition: background-color 160ms ease-out;
  &:hover { background: ${COLORS.FaluRed}; }
  &:focus-visible { outline: 2px solid ${COLORS.Crimson}; outline-offset: 3px; }
  > svg { flex-shrink: 0; }
  @media (max-width: 767px) { width: 100%; padding: 12px 16px; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;

